import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

import { MapControllerProps } from './MapController.type';

export const MapController = ({
  onMapClick,
  shouldFitBounds = false,
  bounds = null,
  useCurrentLocation = true,
}: MapControllerProps) => {
  const map = useMap();

  useEffect(() => {
    map.on('click', onMapClick);

    return () => {
      map.off('click', onMapClick);
    };
  }, [map, onMapClick]);

  useEffect(() => {
    if (shouldFitBounds && bounds && bounds.isValid()) {
      map.fitBounds(bounds, { padding: [15, 15] });
    }
  }, [map, bounds, shouldFitBounds]);

  useEffect(() => {
    if (useCurrentLocation && 'geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          map.setView([latitude, longitude], 13);
        },
        (error) => {
          console.log('Error getting location:', error.message); // eslint-disable-line no-console
        },
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
      );
    }
  }, [map, useCurrentLocation]);

  return null;
}; 